import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ReadyToStartProject from "../components/ReadyToStartProject";
import AOS from "aos";
import "aos/dist/aos.css";

const Ecommerce = () => {
  const [showMore, setShowMore] = useState({});

  const scrollToElement = (text) => {
    document.getElementById(text).scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    AOS.init({
      duration: 1000, // durée de l'animation en millisecondes
      easing: "ease-in-out", // courbe d'accélération
      once: true, // chaque élément sera animé une seule fois
    });
  }, []);

  const toggleShowMore = (index) => {
    setShowMore((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div className="bg-gradient-to-b from-gray-900 to-gray-700 min-h-screen text-white">
      <Helmet>
        <title>Transformez Votre Boutique en Ligne | WebMinds</title>
        <meta
          name="description"
          content="Développez et optimisez votre présence en ligne avec des solutions e-commerce personnalisées. Maximisez vos ventes et offrez une expérience utilisateur exceptionnelle avec nos services e-commerce."
        />
        <meta
          name="keywords"
          content="e-commerce, développement boutique en ligne, optimisation SEO e-commerce, solutions e-commerce, services e-commerce"
        />
        <meta name="author" content="WebMinds" />
        <meta
          property="og:title"
          content="Transformez Votre Boutique en Ligne | WebMinds"
        />
        <meta
          property="og:description"
          content="Développez et optimisez votre présence en ligne avec des solutions e-commerce personnalisées. Maximisez vos ventes et offrez une expérience utilisateur exceptionnelle avec nos services e-commerce."
        />
        <meta property="og:image" content="/images/ecommerce.jpg" />
        <meta property="og:url" content="https://www.webminds.com/ecommerce" />
        <meta property="og:type" content="website" />
      </Helmet>
      <Navbar />

      {/* Section d'introduction avec image de fond */}
      <div
        className="h-screen bg-cover bg-center relative"
        style={{ backgroundImage: `url('/images/ecommerce.jpg')` }}
        data-aos="fade-in"
      >
        <div className="flex items-center justify-center h-full bg-black bg-opacity-60">
          <div className="text-center max-w-3xl">
            <h1 className="text-5xl font-extrabold mb-6">
              Transformez Votre Boutique en Ligne
            </h1>
            <p className="text-2xl mb-6">
              Développez et optimisez votre présence en ligne avec des solutions
              e-commerce personnalisées.
            </p>
            <p className="text-lg mb-8">
              Maximisez vos ventes et offrez une expérience utilisateur
              exceptionnelle avec nos services e-commerce.
            </p>
            <a
              href="javascript:null"
              onClick={() => scrollToElement("why-ecommerce")}
              className="mt-4 px-8 py-3 bg-blue-600 text-white text-lg font-semibold rounded-md shadow-lg hover:bg-blue-700 transition duration-300"
            >
              Découvrir nos services
            </a>
          </div>
        </div>
        <div
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white cursor-pointer animate-bounce"
          onClick={() => scrollToElement("why-ecommerce")}
        >
          <i className="fas fa-chevron-down fa-2x"></i>
        </div>
      </div>

      {/* Section Pourquoi le E-commerce */}
      <div
        id="why-ecommerce"
        className="py-16 px-6 md:px-12 lg:px-24 bg-gray-800"
        data-aos="fade-up"
      >
        <h2 className="text-4xl font-bold mb-8 text-center">
          Pourquoi le E-commerce ?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div data-aos="fade-up" data-aos-delay="100">
            <h3 className="text-2xl font-semibold mb-4">
              Augmentation des Ventes
            </h3>
            <p className="text-lg mb-4">
              Un site e-commerce efficace peut significativement augmenter vos
              ventes en ligne grâce à une meilleure visibilité et une meilleure
              gestion des produits.
            </p>
          </div>
          <div data-aos="fade-up" data-aos-delay="200">
            <h3 className="text-2xl font-semibold mb-4">
              Expérience Utilisateur Optimisée
            </h3>
            <p className="text-lg mb-4">
              Offrez une expérience d'achat fluide et agréable à vos clients,
              avec un design intuitif et des fonctionnalités avancées.
            </p>
          </div>
          <div data-aos="fade-up" data-aos-delay="300">
            <h3 className="text-2xl font-semibold mb-4">
              Gestion Facile des Stocks
            </h3>
            <p className="text-lg mb-4">
              Gérez vos stocks de manière efficace avec des outils intégrés pour
              suivre les niveaux de stock, les commandes et les retours.
            </p>
          </div>
          <div data-aos="fade-up" data-aos-delay="400">
            <h3 className="text-2xl font-semibold mb-4">
              Analyse des Performances
            </h3>
            <p className="text-lg mb-4">
              Obtenez des rapports détaillés sur les performances de votre
              boutique pour améliorer vos stratégies et augmenter votre ROI.
            </p>
          </div>
        </div>
      </div>

      {/* Section de Services */}
      <div className="py-16 bg-gray-900 px-6 md:px-12 lg:px-24">
      <h2 className="text-4xl font-bold mb-8 text-center text-yellow-500">
        Nos Services e-Commerce
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        
        <div
          className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
          data-aos="fade-up"
        >
          <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
            Développement de Boutique en Ligne
          </h3>
          <p className="text-lg mb-4">
            Créez une boutique en ligne professionnelle avec une conception
            sur mesure et une fonctionnalité optimisée.
          </p>
          
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              showMore[0] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <p className="text-lg mb-4">
              Ce service inclut une analyse approfondie de votre marque, des
              maquettes personnalisées et des révisions illimitées pour vous
              assurer que le design final correspond parfaitement à vos
              attentes.
            </p>
          </div>
          <button
            onClick={() => toggleShowMore(0)}
            className="text-blue-500 hover:text-blue-600 transition duration-300"
          >
            {showMore[0] ? "Lire moins" : "Lire plus"} &rarr;
          </button>
        </div>
        
        <div
          className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
            Intégration de Passerelles de Paiement
          </h3>
          <p className="text-lg mb-4">
            Offrez à vos clients des options de paiement sécurisées et diversifiées avec des intégrations de passerelles de paiement.
          </p>
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              showMore[1] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <p className="text-lg mb-4">
              Nous vous aidons à intégrer des solutions de paiement comme PayPal, Stripe et d'autres, tout en garantissant la sécurité des transactions pour vos clients.
            </p>
          </div>
          <button
            onClick={() => toggleShowMore(1)}
            className="text-blue-500 hover:text-blue-600 transition duration-300"
          >
            {showMore[1] ? "Lire moins" : "Lire plus"} &rarr;
          </button>
        </div>
        
        <div
          className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
            Optimisation SEO pour E-commerce
          </h3>
          <p className="text-lg mb-4">
            Améliorez la visibilité de votre boutique en ligne avec des stratégies SEO spécifiques au e-commerce.
          </p>
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              showMore[2] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <p className="text-lg mb-4">
              Nous optimisons vos pages produits, descriptions, et balises pour un meilleur classement sur les moteurs de recherche.
            </p>
          </div>
          <button
            onClick={() => toggleShowMore(2)}
            className="text-blue-500 hover:text-blue-600 transition duration-300"
          >
            {showMore[2] ? "Lire moins" : "Lire plus"} &rarr;
          </button>
        </div>
        
        <div
          className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
            Gestion des Produits et Stocks
          </h3>
          <p className="text-lg mb-4">
            Gérez facilement vos produits, stocks et commandes avec des outils puissants et intuitifs.
          </p>
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              showMore[3] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <p className="text-lg mb-4">
              Nous mettons en place des solutions automatisées pour suivre les stocks en temps réel et éviter les ruptures.
            </p>
          </div>
          <button
            onClick={() => toggleShowMore(3)}
            className="text-blue-500 hover:text-blue-600 transition duration-300"
          >
            {showMore[3] ? "Lire moins" : "Lire plus"} &rarr;
          </button>
        </div>
        
        <div
          className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
          data-aos="fade-up"
          data-aos-delay="400"
        >
          <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
            Analyse des Performances de Vente
          </h3>
          <p className="text-lg mb-4">
            Recevez des rapports détaillés sur les ventes et les comportements des clients pour optimiser vos stratégies.
          </p>
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              showMore[4] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <p className="text-lg mb-4">
              Analysez les données de vente pour identifier les produits les plus performants et ajuster vos offres en conséquence.
            </p>
          </div>
          <button
            onClick={() => toggleShowMore(4)}
            className="text-blue-500 hover:text-blue-600 transition duration-300"
          >
            {showMore[4] ? "Lire moins" : "Lire plus"} &rarr;
          </button>
        </div>
        
        <div
          className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
          data-aos="fade-up"
          data-aos-delay="500"
        >
          <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
            Support et Maintenance
          </h3>
          <p className="text-lg mb-4">
            Bénéficiez d'un support technique et de mises à jour régulières pour assurer le bon fonctionnement de votre boutique.
          </p>
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              showMore[5] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <p className="text-lg mb-4">
              Nous offrons un support continu pour résoudre les problèmes techniques et maintenir vos systèmes à jour.
            </p>
          </div>
          <button
            onClick={() => toggleShowMore(5)}
            className="text-blue-500 hover:text-blue-600 transition duration-300"
          >
            {showMore[5] ? "Lire moins" : "Lire plus"} &rarr;
          </button>
        </div>

      </div>
    </div>

      {/* Section des Tarifs E-commerce */}
      <section
        id="pricing"
        className="py-20 bg-fixed bg-cover bg-center text-center"
        style={{
          backgroundImage: `url('/images/bg-pricing.jpg')`,
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
        }}
        data-aos="fade-up"
      >
        <div className="bg-gradient-to-r from-gray-800 to-gray-900 py-16">
          <h2 className="text-5xl font-bold mb-16 text-yellow-400">
            Nos Tarifs E-commerce Avantageux
          </h2>
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-4">
            {/* Plan de Base */}
            <div
              className="bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 border-2 border-blue-500 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 p-8 relative flex flex-col"
              data-aos="fade-up"
            >
              <div className="absolute top-0 left-0 bg-blue-500 text-white py-2 px-6 text-sm font-bold transform -translate-y-1/2 -translate-x-1/4 rotate-12">
                Populaire
              </div>
              <h3 className="text-2xl font-semibold mb-6 text-yellow-300">
                Forfait de Base
              </h3>
              <p className="text-5xl font-bold mb-6 text-white">1599€</p>
              <ul className="text-left space-y-4">
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Développement de site e-commerce de base
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Intégration des passerelles de paiement
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Formation à l'utilisation
                </li>
              </ul>
              <a
                href="/contact"
                className="mt-auto px-8 py-3 bg-blue-500 text-white-800 font-semibold rounded-md shadow-lg hover:bg-blue-600 transition duration-300"
              >
                Commencer
              </a>
            </div>
            {/* Plan Avancé */}
            <div
              className="bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 border-2 border-yellow-500 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 p-8 relative flex flex-col"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="absolute top-0 left-0 bg-yellow-500 text-white py-2 px-6 text-sm font-bold transform -translate-y-1/2 -translate-x-1/4 rotate-12">
                Le Plus Populaire
              </div>
              <h3 className="text-2xl font-semibold mb-6 text-yellow-300">
                Forfait Avancé
              </h3>
              <p className="text-5xl font-bold mb-6 text-white">2299€</p>
              <ul className="text-left space-y-4 mb-5">
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Développement complet de boutique en ligne
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Optimisation SEO de base
                </li>

                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Support technique pendant 6 mois
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Formation avancée pour l'équipe
                </li>
              </ul>
              <a
                href="/contact"
                className="mt-auto px-8 py-3 bg-yellow-500 text-white-800 font-semibold rounded-md shadow-lg hover:bg-yellow-600 transition duration-300"
              >
                Commencer
              </a>
            </div>
            {/* Plan Pro */}
            <div
              className="bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 border-2 border-red-500 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 p-8 relative flex flex-col"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="absolute top-0 left-0 bg-red-500 text-white py-2 px-6 text-sm font-bold transform -translate-y-1/2 -translate-x-1/4 rotate-12">
                Exclusif
              </div>
              <h3 className="text-2xl font-semibold mb-6 text-yellow-300">
                Forfait Pro
              </h3>
              <p className="text-5xl font-bold mb-6 text-white">2799€ +</p>
              <ul className="text-left space-y-4">
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Développement e-commerce sur mesure
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Optimisation SEO avancée
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Maintenance et support pendant 1 an
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2 mb-10"></i>
                  Consultation stratégique mensuelle
                </li>
              </ul>
              <a
                href="/contact"
                className="mt-auto px-8 py-3 bg-red-500 text-white-800 font-semibold rounded-md shadow-lg hover:bg-red-600 transition duration-300"
              >
                Commencer
              </a>
            </div>
          </div>
          <p className="mt-10 text-gray-400 text-center">
            Les tarifs indiqués sont standards et peuvent varier en fonction de
            vos besoins spécifiques. N’hésitez pas à nous contacter pour un
            devis personnalisé.
          </p>
        </div>
      </section>
      <ReadyToStartProject />
      <Footer />
    </div>
  );
};

export default Ecommerce;
